import React from 'react'
import { Card, Statistic, Typography } from 'antd'
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons'

/** 전기간 대비 증감 표기 (▲▼ %) */
function Delta({ current, previous }: { current: number; previous: number | undefined }) {
  if (previous === undefined) return null
  if (previous === 0) {
    return (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        전기간 0
      </Typography.Text>
    )
  }
  const pct = ((current - previous) / Math.abs(previous)) * 100
  if (pct === 0) {
    return (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        전기간 동일
      </Typography.Text>
    )
  }
  const up = pct > 0
  return (
    <Typography.Text style={{ fontSize: 12, color: up ? '#3f8600' : '#cf1322' }}>
      {up ? <ArrowUpOutlined /> : <ArrowDownOutlined />} {Math.abs(pct).toFixed(1)}% (전기간 대비)
    </Typography.Text>
  )
}

interface StatCardProps {
  title: React.ReactNode
  value: string | number
  /** 전기간 값 — 전달 시 증감 ▲▼% 표시 */
  previous?: number
  /** previous와 비교할 현재 숫자값 (value가 포맷 문자열일 때 사용) */
  rawValue?: number
  suffix?: React.ReactNode
  valueColor?: string
  loading?: boolean
}

/** KPI 카드 — Statistic + 전기간 대비 증감 */
export default function StatCard({ title, value, previous, rawValue, suffix, valueColor, loading }: StatCardProps) {
  const current = rawValue ?? (typeof value === 'number' ? value : undefined)
  return (
    <Card size="small" loading={loading}>
      <Statistic title={title} value={value} suffix={suffix} valueStyle={valueColor ? { color: valueColor } : undefined} />
      {current !== undefined && <Delta current={current} previous={previous} />}
    </Card>
  )
}
